import { useState } from 'react';
import { useFetch } from '../../hooks/useFetch';
import { faqApi } from '../../api/contentApi';
import { Button } from '../../components/ui/Button';

const VIDE = { question: '', reponse: '', univers: 'commun', ordre: 0, statut: 'publie' };

export function FaqManager() {
  const { data: faqs, loading, refetch } = useFetch(() => faqApi.adminList(), []);
  const [edition, setEdition] = useState(null);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  function ouvrirCreation() {
    setEdition({ ...VIDE });
    setErrors({});
  }

  function ouvrirEdition(faq) {
    setEdition({ ...VIDE, ...faq });
    setErrors({});
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    setErrors({});

    try {
      if (edition.id) {
        await faqApi.update(edition.id, edition);
      } else {
        await faqApi.create(edition);
      }
      setEdition(null);
      refetch();
    } catch (err) {
      setErrors(err.errors || { _global: err.message });
    } finally {
      setSubmitting(false);
    }
  }

  async function handleDelete(id) {
    if (!window.confirm('Supprimer cette question ?')) return;
    await faqApi.remove(id);
    refetch();
  }

  if (loading) return <p>Chargement...</p>;

  return (
    <section>
      <div className="admin-toolbar">
        <h1>FAQ</h1>
        {!edition && <Button onClick={ouvrirCreation}>+ Nouvelle question</Button>}
      </div>

      {edition && (
        <form className="admin-form" onSubmit={handleSubmit}>
          <div className="admin-form__field">
            <label>Question</label>
            <input value={edition.question} onChange={(e) => setEdition({ ...edition, question: e.target.value })} required />
            {errors.question && <span className="admin-form__error">{errors.question}</span>}
          </div>

          <div className="admin-form__field">
            <label>Réponse</label>
            <textarea
              rows={4}
              value={edition.reponse}
              onChange={(e) => setEdition({ ...edition, reponse: e.target.value })}
              required
            />
            {errors.reponse && <span className="admin-form__error">{errors.reponse}</span>}
          </div>

          <div className="admin-form__field">
            <label>Univers</label>
            <select value={edition.univers} onChange={(e) => setEdition({ ...edition, univers: e.target.value })}>
              <option value="commun">Commun</option>
              <option value="particulier">Particulier</option>
              <option value="professionnel">Professionnel</option>
            </select>
          </div>

          <div className="admin-form__field">
            <label>Ordre d'affichage</label>
            <input
              type="number"
              value={edition.ordre}
              onChange={(e) => setEdition({ ...edition, ordre: Number(e.target.value) })}
            />
          </div>

          {errors._global && <p className="admin-form__error">{errors._global}</p>}

          <div className="admin-form__actions">
            <Button type="submit" disabled={submitting}>
              {edition.id ? 'Enregistrer' : 'Créer'}
            </Button>
            <Button type="button" variant="secondary" onClick={() => setEdition(null)}>
              Annuler
            </Button>
          </div>
        </form>
      )}

      <table className="admin-table">
        <thead>
          <tr>
            <th>Question</th>
            <th>Univers</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {faqs?.map((f) => (
            <tr key={f.id}>
              <td>{f.question}</td>
              <td>{f.univers}</td>
              <td className="admin-table__actions">
                <button onClick={() => ouvrirEdition(f)}>Modifier</button>
                <button onClick={() => handleDelete(f.id)}>Supprimer</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
